<template>
  <div>
    手机端
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ScanCode from "@/components/ScanCode.vue";
import Footer from "@/components/Footer.vue";
import { toTop } from "@/api/date.js";
import {
  getMentalCourse,
  getMix,
  config,
  advertising,
  teacher
} from "@/api/api.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Header,
    ScanCode,
    Footer
  },
  data() {
    return {
      imglist: [],
      img_url: "",
      lisindex: 0,
      lists: [
        {
          url: "/",
          id: 0,
          title: "首页"
        },
        {
          url: "/dynamic",
          id: 1,
          title: "心理动态"
        },
        {
          url: "/Evaluation",
          id: 2,
          title: "心理测评"
        },
        {
          url: "/curriculum",
          id: 3,
          title: "课程中心"
        },
        {
          url: "/Parent",
          id: 4,
          title: "家长大学"
        },
        {
          url: "/Sansheng",
          id: 5,
          title: "三生教育"
        },
        {
          url: "/AboutUs",
          id: 6,
          title: "关于我们"
        },
        {
          url: "/AboutUs",
          id: 7,
          title: "联系我们"
        }
      ],
      Courselist: [],
      evaluationlist: [], //测评列表
      dynamiclist: [],
      teacherlist: [],
      swiperOption: {
        autoplay: {
          //可选选项，自动滑动
          disableOnInteraction: false, //用户操作后是否禁止自动循环
          delay: 3000 //自动循环时间
        },
        speed: 2000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
        loop: true, //循环切换
        slidesPerView: 3,
        spaceBetween: 1,
        grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
        scrollbar: ".swiper-scrollbar",
        // observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
        navigation: {
          nextEl: ".zuobian",
          prevEl: ".youbian"
        }
      }
    };
  },
  computed: {},
  mounted() {
    this.config();
    this.advertising();
    this.getMentalCourse();
    this.getMix();
    this.teacher();
  },
  methods: {
    advertising() {
      advertising({
        position_type: 1
      }).then(res => {
        this.imglist = res;
      });
    },
    gobannerurl(url) {
      if (url && url.indexOf("http") >= 0) {
        window.open(url, "_blank");
      } else {
        this.$router.push({ path: url });
      }
    },
    config() {
      config({}).then(res => {
        this.img_url = res.img_url;
        localStorage.setItem("img_url", this.img_url);
      });
    },
    goindex() {
      this.$router.push({ name: "index" });
    },
    gourl(list, index) {
      if (list.id == 7) {
        setTimeout(this.toBottom(), 2000);
      } else {
        this.$router.push({ path: list.url });
      }
    },
    //去底部
    toBottom() {
      // 滚动内容的坐标位置0,50000：
      window.scrollTo(0, 50000);
    },
    getMentalCourse() {
      getMentalCourse({
        limit: 3
      }).then(res => {
        this.Courselist = res;
      });
    },
    getMix() {
      getMix({
        limit: 4
      }).then(res => {
        this.evaluationlist = res.evaluation;
        this.dynamiclist = res.dynamic;
      });
    },
    teacher() {
      teacher({
        limit: 10
      }).then(res => {
        this.teacherlist = res;
      });
    },
    gocurriculum(id) {
      toTop();
      this.$router.push({ name: "curriculum", query: { id: id } });
    },
    gonewdetails(id) {
      let routeData = this.$router.resolve({
        name: "newdetails",
        query: { id: id }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style scoped lang="less">
/deep/.el-carousel__button {
  background-color: #5f98ea;
  height: 5px;
  border-radius: 16px;
}
/deep/ .tiyan_div .el-carousel__arrow--left {
  font-size: 20px;
  font-weight: bold;
  width: 55px;
  height: 65px;
  margin-top: -80px;
  background: #5f98ea;
  border-radius: 8px;
}
/deep/ .tiyan_div .el-carousel__arrow--right {
  font-size: 20px;
  font-weight: bold;
  width: 55px;
  height: 65px;
  margin-top: -80px;
  background: #5f98ea;
  border-radius: 8px;
}
.header_div {
  // background: transparent;
  width: 100%;
  height: 96px;
  position: absolute;
  top: 0;
  z-index: 10000;
  @media screen and (min-width:300px) and (max-width: 700px) {
   display: none;
  }
  @media screen and (min-width:1000px) {
    display: block;
  }
}
.logo {
  width: 126px;
  height: 53px;
  margin-top: 20px;
}
.header_ul li {
  float: left;
  margin-left: 10px;
}
.header_ul li div {
  width: 80px;
  line-height: 95px;
  height: 95px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  text-align: center;
}
.active {
  color: #fff !important;
}
.active::before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 4px;
  background: url("../../public/heads/active1.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  position: absolute;
  bottom: 22px;
  left: 32px;
}
.banner_div {
  width: 100%;
  height: 620px;
}
.xinlikecheng {
  width: 100%;
  height: 712px;
  background-color: #fafafb;
  .kechengdiv1 {
    width: 370px;
    height: 440px;
    border-radius: 16px;
    background-color: #fff;
    margin: 0 10px;
    .kechengimg {
      width: 370px;
      height: 240px;
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
    }
    .kechengtitle {
      height: 50px;
      line-height: 50px;
      .hot {
        width: 35px;
        height: 19px;
        float: left;
        margin-top: 15px;
      }
    }
    .kechengtitle :hover {
      color: #5f98ea;
    }
    .kechengdiv1_ul li {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px dashed #ddd;
    }
    .kechengdiv1_ul li:last-child {
      border: none;
    }
    .kechengdiv1_ul li :hover {
      color: #5f98ea;
    }
  }
}
.title_p {
  color: #3b3e43;
  font-size: 26px;
  text-align: center;
  padding: 60px 0;
  font-weight: bold;
  position: relative;
}
.title_p::before {
  content: "";
  display: inline-block;
  background-color: #5f98ea;
  width: 30px;
  height: 8px;
  position: absolute;
  bottom: 45px;
  left: 583px;
  border-radius: 10px;
}
.youshi {
  width: 100%;
  height: 1029px;
  background-color: #fff;
  position: relative;
  .youshi_ul li {
    box-shadow: #eee 5px 5px 10px 2px; //边框阴影
    text-align: center;
    float: left;
    width: 23%;
    margin: 0 1%;
    height: 230px;
    border-radius: 10px;
    color: #3b3e43;
    .youshi_ul_li_img {
      margin-top: 38px;
    }
    .youshi_title {
      font-size: 18px;
      font-weight: bold;
      margin: 15px 0;
    }
    .youshi_content {
      font-size: 14px;
      padding: 0 10px;
      line-height: 22px;
    }
  }
  .bgimg {
    position: absolute;
    width: 642px;
    height: 382px;
    background: url("../../public/index/1.png") no-repeat 100% 100%;
    background-size: 100% 100%;
    left: 280px;
    top: 120px;
  }
  .choicediv1 {
    text-align: center;
    margin: 0 50px;
    .num {
      color: #000;
      font-size: 30px;
      font-weight: bold;
    }
    .title {
      color: #3b3e43;
      font-size: 16px;
      margin-top: 5px;
    }
    .content {
      color: #999;
      margin-top: 20px;
      font-size: 12px;
      line-height: 20px;
    }
  }
}
.fudao {
  width: 100%;
  height: 947px;
  background: url("../../public/index/BG.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  .fudaodiv1 {
    width: 560px;
    height: 660px;
    background: url("../../public/index/fudao.png") no-repeat 100% 100%;
    background-size: 100% 100%;
    border-radius: 16px;
    margin: 0 15px;
    position: relative;
    .title {
      color: #fff;
      font-size: 28px;
      position: absolute;
      top: 50px;
      left: 50px;
    }
    .fudaodiv1_ul {
      position: absolute;
      left: 50px;
      top: 180px;
      width: 80%;
      li {
        margin-bottom: 60px;
      }
      .content {
        font-size: 12px;
        color: #999;
        line-height: 20px;
        margin-top: 10px;
      }
    }
  }
  .xianxiabg {
    background: url("../../public/index/xianxiabg.png") no-repeat 100% 100%;
  }
}
.ceping {
  width: 100%;
  height: 536px;
  background-color: #fff;
  .cepingdiv {
    width: 278px;
    height: 324px;
    border-radius: 16px;
    margin: 0 20px;
    box-shadow: #eee 5px 5px 10px 2px;
    .cepingimg {
      width: 276px;
      height: 161px;
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
    }
    .title {
      color: #3b3e43;
      font-size: 16px;
      text-align: center;
      padding: 35px 0;
    }
    .title:hover {
      color: #5f98ea;
    }
    .bts {
      background-color: #5f98ea;
      color: #fff;
      line-height: 40px;
      height: 40px;
      text-align: center;
      width: 106px;
      margin: auto;
      border-radius: 50px;
    }
  }
}
.dongtai {
  width: 100%;
  height: 723px;
  background: #fafafb;
  .dongtai_ul {
    .year_yue {
      color: #999;
      font-size: 16px;
      font-weight: bold;
      margin: 10px 35px;
    }
    li {
      margin-top: 30px;
      float: left;
      width: 50%;
      .wenzhang {
        margin: auto;
        border-radius: 16px;
        background-color: #fff;
        width: 400px;
        height: 160px;
        padding: 0 68px;
        position: relative;
        .day {
          position: absolute;
          left: -30px;
          top: 35px;
          width: 76px;
          height: 76px;
          line-height: 76px;
          text-align: center;
          background-color: #5f98ea;
          font-size: 30px;
          color: #fff;
          border-radius: 5px;
        }
        .title {
          color: #3b3e43;
          font-size: 18px;
          padding-top: 20px;
          font-weight: bold;
        }
        .title:hover {
          color: #5f98ea;
        }
        .content {
          color: #999;
          font-size: 12px;
          padding-top: 10px;
          line-height: 20px;
        }
        .content:hover {
          color: #5f98ea;
        }
        .look {
          position: absolute;
          right: 0;
          bottom: 0;
          background-color: #e7edf5;
          width: 84px;
          text-align: center;
          height: 32px;
          line-height: 32px;
          border-top-left-radius: 16px;
          border-bottom-right-radius: 16px;
          color: #8292a7;
        }
      }
    }
  }
}
.zhuanjia {
  width: 100%;
  height: 566px;
  background: url("../../public/index/BG2.png") no-repeat 100% 100%;
  background-size: 100% 100%;

  .zhuanjia_div {
    .zhuanjia_content {
      background-color: #fff;
      border-radius: 16px;
      width: 268px;
      height: 368px;
      margin-right: 30px;
      .img {
        border-radius: 50%;
        width: 188px;
        height: 188px;
        margin: 20px auto;
        display: block;
      }
      .p1 {
        color: #3b3e43;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
      .p2 {
        text-align: center;
        font-size: 14px;
        padding: 10px 20px;
      }
    }
    .zuobian {
      position: relative;
      top: 110px;
    }
    .youbian {
      position: relative;
      top: 100px;
    }
  }
}
.weiyuanhui {
  width: 100%;
  height: 850px;
  background-color: #fff;
  .why_div {
    margin-top: 30px;
    .touxiang {
      margin-right: 30px;
      float: left;
      width: 168px;
      padding-right: 32px;
      .img168 {
        width: 168px;
        height: 168px;
      }
      .p {
        text-align: center;
        font-size: 14px;
      }
    }
    .content {
      position: relative;
      .p1 {
        font-size: 18px;
        padding-top: 55px;
        font-weight: bold;
      }
      .p2 {
        font-size: 14px;
        margin: 15px 138px 0 0;
        line-height: 25px;
      }
      .i1 {
        width: 31px;
        height: 29px;
        background: url("../../public/index/dou1.png") no-repeat 100% 100%;
        background-size: 100% 100%;
        position: absolute;
        top: 25px;
        left: 200px;
      }
      .i2 {
        width: 31px;
        height: 29px;
        background: url("../../public/index/dou2.png") no-repeat 100% 100%;
        background-size: 100% 100%;
        position: absolute;
        bottom: -30px;
        right: 138px;
      }
    }
  }
  .service {
    .title1 {
      font-size: 26px;
      margin-top: 80px;
      font-weight: bold;
    }
    .service_ul {
      li {
        margin: 50px 120px 0 0;
        .biaoti_p {
          color: #3b3e43;
          font-size: 18px;
          font-weight: bold;
          position: relative;
          margin-left: 20px;
        }
        .biaoti_p::before {
          content: "";
          display: inline-block;
          background-color: #5f98ea;
          width: 8px;
          height: 22px;
          position: absolute;
          bottom: 1px;
          left: -15px;
          border-radius: 10px;
        }
        .neirong {
          margin-top: 10px;
          width: 270px;
          line-height: 25px;
        }
      }
    }
  }
}
</style>
